import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { Action } from "redux";
import { routerReducer } from "react-router-redux";

import auth, { AuthState } from "./modules/auth/auth";
import chats, { ChatState } from "./modules/chats/chats";
import messages, { MessageState } from "./modules/messages/messages";
import contacts, { ContactState } from "./modules/contacts/contacts";
import users, {UserState } from "./modules/users/users";
import ui, { IUiState } from "./modules/ui/ui";

import appChats, { AppChatsState } from "./modules/appChats/appChats";
import appContacts, { AppContactsState } from "./modules/appContacts/appContacts";
import appAuth, { AppAuthState } from "./modules/appAuth/appAuth";

export interface Action<T>{
  type: string;
  payload?: T;
  error?: boolean;
  meta?: any;
}

export interface RootState {
    auth: AuthState;
    entities: {
        chats: ChatState;
        messages: MessageState;
        contacts: ContactState;
        users: UserState;
    };
    appChats: AppChatsState;
    appContacts: AppContactsState;
    appAuth: AppAuthState;
    ui: IUiState;
    routing: any;
}

function logout() {

}

const appReducer = combineReducers({
    auth,
    entities: combineReducers({
        chats,
        messages,
        contacts,
        users
    }),
    appChats,
    appAuth,
    appContacts,
    form: formReducer,
    ui,
    routing: routerReducer
});

const rootReducer = (state: {}, action: Action) => {
    if (action.type === "USER_LOGOUT") {
        state = undefined;
    }

    return appReducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/index.ts